import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../utils/api";
import { API_ENDPOINTS, STORAGE_KEYS } from "../constants/api";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in on app start
    const storedToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
    const storedUser = localStorage.getItem(STORAGE_KEYS.USER);

    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));

      console.log("storedUser", JSON.parse(storedUser).id);

      api
        .get(
          `${API_ENDPOINTS.LAWYERS.GET_BY_ID}/${JSON.parse(storedUser).id}`,
          {
            headers: { Authorization: `Bearer ${storedToken}` },
          }
        )
        .then((response) => {
          if (response.ok && response.data.lawyer) {
            setUser(response.data.lawyer);
            localStorage.setItem(
              STORAGE_KEYS.USER,
              JSON.stringify(response.data.lawyer)
            );
          } else {
            logout();
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          logout();
        })
        .finally(() => setLoading(false));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post(API_ENDPOINTS.AUTH.LOGIN, {
        email,
        password,
      });

      if (response.ok && response.data.token) {
        // Store token and user data
        localStorage.setItem(STORAGE_KEYS.TOKEN, response.data.token);
        localStorage.setItem(
          STORAGE_KEYS.USER,
          JSON.stringify(response.data.lawyer)
        );

        setToken(response.data.token);
        setUser(response.data.lawyer);

        return { success: true, data: response.data };
      } else {
        return {
          success: false,
          error: response.data.message || "Login failed",
        };
      }
    } catch (error) {
      console.error("Login error:", error);
      return {
        success: false,
        error: "Network error. Please try again.",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
    setToken(null);
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!(token && user);
  };

  const value = {
    user,
    token,
    loading,
    login,
    logout,
    isAuthenticated,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
